export const data = [
    {
        id: "0",
        question: "Can you use imperial and metric tools interchangeably?",
        answer: "",
        variants: [`Usually, no. Even if they fit, they can easily strip screws`, `No, they will never fit.`, `Sometimes, yes. They can be easier to use than the correct tool.`, `Yes, all tools are interchangeable.`]
    },
    {
        id: "1",
        question: "What does the '32' in a '10-32' bolt mean?",
        answer: "It has 32 threads per inch.",
        variants: [`It is the 32nd version of the bolt.`, `It uses a 3.2 millimeter-wide bit`, `It is 32 millimeters long.`, `It has 32 threads per inch.`]
    },
]

// {
//     id: "3",
//     question: "",
//     answer: "",
//     variants: [``, ``]
// },